<template>
  <v-container
    @contextmenu="show"
    :dark="$store.getters.getColorPalette().isDark"
    fluid
  >
    <InfoAlert
      :showDismissibleAlert="showDismissibleAlert"
      v-on:close="showDismissibleAlert = false"
      :info="info"
    />
    <v-menu
      v-model="showMenu"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
      v-if="$store.state.settingMode && edit"
    >
      <v-list
        :dark="$store.getters.getColorPalette().isDark"
        :color="$store.getters.getColorPalette().backgroundColorCode"
      >
        <v-list-item @click="update = true">
          <v-list-item-title
            ><strong>{{
              $store.getters.getTextMap().edit
            }}</strong></v-list-item-title
          >
          <v-list-item-icon>
            <v-icon small>mdi-pencil</v-icon>
          </v-list-item-icon>
        </v-list-item>
        <v-list-item @click="deleteWidget">
          <v-list-item-title
            ><strong
              >{{ $store.getters.getTextMap().delete }}
            </strong></v-list-item-title
          >
          <v-list-item-icon>
            <v-icon color="red" small>mdi-trash-can</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-menu>
    <v-dialog
      v-model="update"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card
        :dark="$store.getters.getColorPalette().isDark"
        :color="$store.getters.getColorPalette().backgroundColorCode"
      >
        <v-toolbar
          :dark="$store.getters.getColorPalette().isDark"
          :color="$store.getters.getColorPalette().foregroundColorCode"
        >
          <v-btn
            icon
            :dark="$store.getters.getColorPalette().isDark"
            @click="update = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ widget.label }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn
              :dark="$store.getters.getColorPalette().isDark"
              text
              @click="update = false"
              >{{ $store.getters.getTextMap().close }}
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <AddManufacturingLogbookKpiBartrendWidget
          :widget="widget"
          :disableTimeframe="disableTimeframe"
          v-on:close="update = false"
          v-on:success="$emit('update')"
        />
      </v-card>
    </v-dialog>
    <v-skeleton-loader
      v-if="loading"
      class="mx-auto"
      type="text"
    ></v-skeleton-loader>
    <div
      v-if="graphData"
      ref="vis"
      :style="[
        widget.height === 'fixed'
          ? {
              'background-color': widget.background_color
                ? widget.background_color
                : $store.getters.getColorPalette().background2ColorCode,
              height: '175px',
            }
          : {},
      ]"
    ></div>
    <div
      v-else
      :style="[
        widget.height === 'fixed'
          ? { height: '175px', 'text-align': 'center' }
          : { 'text-align': 'center' },
      ]"
    >
      <v-icon small>mdi-hail</v-icon>
      <h5>{{ $store.getters.getTextMap().not_configured }}</h5>
    </div>
  </v-container>
</template>
<script>
import InfoAlert from "@/components/InfoAlert";
import axios from "axios";
import Plotly from "plotly.js";
import ColorUtility from "@/utillities/ColorUtility";
import moment from "moment";
import AddManufacturingLogbookKpiBartrendWidget from "@/components/crud_components/widgets/AddManufacturingLogbookKpiBartrendWidget";
export default {
  name: "ManufacturingLogbookKpiBartrendWidget",
  props: ["widget", "seq", "timeframe", "disableTimeframe", "edit"],
  components: {
    InfoAlert,
    AddManufacturingLogbookKpiBartrendWidget,
  },
  data() {
    return {
      colorCode: ColorUtility.colorTypesCodeArray,
      showDismissibleAlert: false,
      info: "",
      loading: false,
      x: 0,
      y: 0,
      showMenu: false,
      update: false,
      graphData: {},
      dbData: [],
      layout: {
        font: {
          color: this.$store.getters.getColorPalette().accentCode,
        },
        plot_bgcolor: this.widget.background_color
          ? this.widget.background_color
          : this.$store.getters.getColorPalette().background2ColorCode,
        paper_bgcolor: this.widget.background_color
          ? this.widget.background_color
          : this.$store.getters.getColorPalette().background2ColorCode,
        showlegend: true,
        autosize: true,
        hoverlabel: {
          namelength: -1,
        },
        xaxis: {
          tickangle: -45,
          zeroline: false,
          showgrid: true,
          showticklabels: true,
          color: this.$store.getters.getColorPalette().accentCode,
        },
        yaxis: {
          showticklabels: true,
          color: this.$store.getters.getColorPalette().accentCode,
        },
        uniformtext: {
          mode: "hide",
          minsize: 1,
        },
      },
    };
  },
  mounted() {
    if (
      this.widget &&
      this.widget.meta &&
      this.widget.meta.logbook_id &&
      this.widget.meta.kpi &&
      this.widget.meta.timeFrame
    ) {
      this.getData();
    }
  },
  methods: {
    show(e) {
      e.preventDefault();
      this.showMenu = false;
      this.x = e.clientX;
      this.y = e.clientY;
      if (this.$store.state.settingMode) {
        this.$nextTick(() => {
          this.showMenu = true;
        });
      }
    },
    createGraph() {
      this.graphData = {};
      this.layout["title"] = this.widget.label;
      if (this.widget.meta && this.widget.meta.yaxisLabel) {
        this.layout.yaxis["title"] = this.widget.meta.yaxisLabel;
      }
      if (this.widget.meta && this.widget.meta.xaxisLabel) {
        this.layout.xaxis["title"] = this.widget.meta.xaxisLabel;
      }
      if (this.widget.meta && this.widget.meta.legend) {
        this.layout["showlegend"] = true;
      }
      for (let i of this.dbData) {
        if (!(i.metric in this.graphData)) {
          let type = this.widget.meta.graph_type == 1 ? "line" : "bar";
          this.graphData[i.metric] = {
            x: [],
            y: [],
            name: i.metric,
            type: type,
            opacity: 0.9,
            marker: {
              line: {
                color: this.$store.getters.getColorPalette().accentCode,
                width: 1,
              },
            },
          };
        }
        this.graphData[i.metric]["x"].push(
          moment(i.date, "YYYYMMDD").format("DD-MM-YYYY")
        );
        this.graphData[i.metric]["y"].push(i.total_val);
      }
      Plotly.newPlot(
        this.$refs.vis,
        Object.values(this.graphData),
        this.layout,
        { displaylogo: false }
      );
    },
    getData() {
      if (this.widget.height === "fixed") {
        this.layout.height = 170;
        this.layout.font = {
          size: 8,
          color: this.$store.getters.getColorPalette().accentCode,
        };
        this.layout.margin = {
          t: 40,
          b: 40,
          l: 40,
          r: 40,
        };
      }
      this.layout.colorway = this.colorCode;
      this.dbData = [];
      let from_date = moment().subtract(1, "days").format("YYYYMMDD");
      let tf = null;
      if (this.timeframe && this.disableTimeframe) {
        tf = this.timeframe;
      } else {
        tf =
          this.widget.meta && this.widget.meta.timeFrame
            ? this.widget.meta.timeFrame
            : "mtd";
      }
      switch (tf) {
        case "7":
          from_date = moment().subtract(7, "days").format("YYYYMMDD");
          break;

        case "30":
          from_date = moment().subtract(30, "days").format("YYYYMMDD");
          break;

        case "60":
          from_date = moment().subtract(60, "days").format("YYYYMMDD");
          break;

        case "90":
          from_date = moment().subtract(90, "days").format("YYYYMMDD");
          break;

        case "180":
          from_date = moment().subtract(180, "days").format("YYYYMMDD");
          break;

        case "365":
          from_date = moment().subtract(365, "days").format("YYYYMMDD");
          break;

        case "yesterday":
          from_date = moment().subtract(1, "days").format("YYYYMMDD");
          break;

        case "ytd":
          from_date = moment().startOf("year").format("YYYYMMDD");
          break;

        default:
          from_date = moment()
            .subtract(1, "days")
            .startOf("month")
            .format("YYYYMMDD");
          break;
      }
      this.loading = true;
      let payload = {
        kpi: this.widget.meta.kpi,
        logbook_id: this.widget.meta.logbook_id,
        from_date,
      };
      axios
        .post(
          this.$store.state.api + "getManufacturingLogbookKPIDataBetweenDate",
          payload,
          {
            headers: { Authorization: "Bearer " + this.$store.state.jwt },
          }
        )
        .then((response) => {
          if (response.data.status == "success") {
            this.dbData = response.data.data;
            this.createGraph();
          } else {
            this.info = response.data.msg;
            this.showDismissibleAlert = true;
          }
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.info = err;
          this.showDismissibleAlert = true;
        });
    },
    deleteWidget() {
      this.loading = true;
      axios
        .post(this.$store.state.api + "deleteWidget", this.widget, {
          headers: {
            Authorization: "Bearer " + this.$store.state.jwt,
          },
        })
        .then((response) => {
          if (response.data.status === "success") {
            this.dialog = false;
            this.loading = false;
            this.$emit("update");
          }
        })
        .catch((err) => {
          console.error(err);
          this.loading = false;
        });
    },
  },
  watch: {
    timeframe() {
      this.getData();
    },
    widget() {
      this.getData();
    },
  },
};
</script>
